

import React, { Component, useState, useEffect } from 'react'
import Select from 'react-select'
import { ApiAdapter } from "./adapters";
import { useTranslation } from "react-i18next";

import {
  collapseTextChangeRangesAcrossMultipleVersions,
  isConstructorDeclaration,
} from "typescript";


const InviteCareTeamMembers: React.FC<any> = ({ my_propa }) => {

  var newApi = (my_propa != undefined) ? my_propa : new ApiAdapter();
  var use_api = (my_propa != undefined) ? false : true;
  var [my_prop, set_prop] = useState(my_propa);
  const [api] = useState(newApi);

  const { t, i18n } = useTranslation();

  const [selectedOptions, setSelected] = useState([]);

  useEffect(() => {
    var elem = document.getElementById("patient")
    elem.addEventListener("reset", reset);
  }, [selectedOptions])
  const reset = () => {
    setSelected([]);

  }
  useEffect(() => {
    var elem = document.getElementById("patient")
    elem.addEventListener("result", updateApi);
  });
  useEffect(() => {
    updatePreview()
  }, []);
  useEffect(() => {
    updatePreview()
  }, [selectedOptions]);

  const updatePreview = () => {
    window["update_preview"]()
  }

  const updateApi = () => {
    if (use_api) {
      api
        .loadProviders()
        .then((resp) => {
          set_prop(resp)
        })
        .catch((errors) => console.log("DELETE_ME handle index errors:", errors));

    }
  }
  const mynoOptionsMessage=(inputValue) => {
    return t("views.show_patient.video_call_invitation.drop_down.providers");
  }

  const onChange = selectedOptions => {
    if (selectedOptions == undefined){
      selectedOptions = []
    }
    setSelected(selectedOptions);
    window["update_preview"]();
  };

const myPlaceHolder = () => {
  return t("views.show_patient.video_call_invitation.drop_down.select");
}


  return (
    <div>
      <Select
        value={selectedOptions}
        isMulti
        options={my_prop}
        onChange={onChange}
        placeholder={t("views.show_patient.video_call_invitation.drop_down.select_provider")}
        noOptionsMessage={mynoOptionsMessage}
        name="invited_provider"
        className="basic-multi-select"
        classNamePrefix="select"
      />
      {selectedOptions.map((item, i) =>
        <input key={item.value} type="hidden" contact_name={item.label} value={item.value} data_name="provider_id" className="invited-provider custom-control-input" id="invited_provider" />
      )}

    </div>
  );
}

export default InviteCareTeamMembers;